// The guided tour of My List. Steps point at [data-tour] anchors on
// MyListPage. The priority and reminder controls only show once the quick add
// box is open, so those steps open it first; the card steps point at the first
// card, and show centred when the list is empty.

export const MY_LIST_TOUR_ID = 'my-list';

// Focusing the quick add box is what opens it (its own onFocus).
const openQuickAdd = () => {
  document.querySelector('[data-tour="mylist-add"] input')?.focus();
};

export const myListTourSteps = [
  {
    title: 'My List',
    target: '[data-tour="mylist-header"]',
    body: [
      'Your own notes, kept as cards. Nobody else sees them unless you share one.',
      'Use Next to walk through, or Skip if you would rather explore. Either way it will not pop up again; the ? by the title replays it.',
    ],
  },
  {
    title: 'Adding a note',
    target: '[data-tour="mylist-add"]',
    before: openQuickAdd,
    body: [
      'Type a title and press Enter to add it straight away. Clicking in the box also opens space for more detail, a priority, a pin and a reminder.',
    ],
  },
  {
    title: 'Priority and pinning',
    target: '[data-tour="mylist-priority"]',
    before: openQuickAdd,
    body: [
      'Each note is High, Normal or Low. The colour down the left edge of a card shows which. High notes sort to the top of your list, Low to the bottom.',
      'Pin a note to keep it above everything else, whatever its priority. The pin on each card turns it on and off.',
    ],
  },
  {
    title: 'Reminders',
    target: '[data-tour="mylist-reminder"]',
    before: openQuickAdd,
    body: [
      'Pick a date and time, or one of the quick choices. When it comes round, the note shows in your notifications and My List gets a count in the sidebar.',
      'The count stays until you tick the note off or clear the reminder. There is no email.',
    ],
  },
  {
    title: 'Finding a note',
    target: '[data-tour="mylist-filters"]',
    body: [
      'Open is what is still on your list, Done is what you have ticked off, and Shared with me is notes colleagues have shared with you. Narrow any of them by priority, or search the titles and text.',
    ],
  },
  {
    title: 'A card',
    target: '[data-tour="mylist-card"]',
    body: [
      'Tick the box to mark a note done. It moves to the Done tab, and ticking it again there puts it back. Edit changes anything about the note, including its reminder.',
    ],
  },
  {
    title: 'Sharing a note',
    target: '[data-tour="mylist-share"]',
    body: [
      'Share sends a read-only copy to the colleagues you pick. They find it under Shared with me and get a notification. They cannot change it, but your later edits show for them.',
      'They can take it off their own list. Removing everybody from the share, or deleting the note, takes it off theirs too.',
    ],
  },
  {
    title: 'Making it an Action',
    target: '[data-tour="mylist-action"]',
    body: [
      'When a note turns into something somebody has to do, Make an Action opens the New Action dialog filled in from the note, with the reminder date as the due date.',
      'Once you raise it, the note is ticked off and keeps a link to the Action, so you can follow it from here.',
    ],
  },
];
